import { Link } from "@mui/material"
import { Link as NavLink } from "react-router-dom"

export const obj1 = {
  title: "1. Acceptance of Terms & User Eligibility",
  subTitle: "Welcome to InnerPal.com (\"InnerPal,\" \"we,\" \"us,\" or \"our\"). By accessing or using our website, mobile interface, tools, or services (collectively, the \"Platform\"), you agree to be bound by these Terms and Conditions (\"Terms\").",
  list: [
    {
      key: "Age Requirement:",
      summary: "You must be at least 18 years of age (or the legal age of majority in your jurisdiction) to create an account or use our Platform.",
    },
    {
      key: "Agreement to Terms:",
      summary: "If you do not agree with any part of these Terms, you must immediately cease using InnerPal and our services.",
    },
    {
      key: "Account Responsibility:",
      summary: "You represent that all information provided during registration is true, accurate, current, and complete.",
    },
  ]
}

export const obj2 = {
  title: "2. Non-Medical & Non-Clinical Disclaimer",
  subTitle: "PLEASE READ THIS SECTION CAREFULLY. INNERPAL IS NOT A MEDICAL PROVIDER OR CLINICAL THERAPY SERVICE.",
  list: [
    {
      key: "No Medical Advice:",
      summary: "InnerPal provides emotional wellness support, self-help courses, community workshops, and access to independent coaches/specialists. We do not provide clinical psychiatric care, psychotherapy, medical diagnosis, or medical treatment.",
    },
    {
      key: "Not an Emergency Hotline:",
      summary: "InnerPal is not designed for crisis situations. If you are experiencing a mental health emergency, severe distress, or thoughts of self-harm, please call 911 (or your local emergency services) or reach out to a certified crisis lifeline immediately (e.g., 988 in the US/Canada).",
    },
    {
      key: "No Doctor-Patient Relationship:",
      summary: "Using InnerPal does not establish a doctor-patient, therapist-patient, or clinical relationship between you and InnerPal or any Specialist.",
    },
  ]
}

export const obj3 = {
  title: "3. Independent Wellness Specialists",
  subTitle: "InnerPal connects Members with independent wellness guides, life coaches, platonic companions, and mentors (\"Specialists\").",
  list: [
    {
      key: "Independent Contractors:",
      summary: "Specialists are independent contractors, not employees or direct agents of InnerPal. InnerPal provides the technology platform to facilitate connections and bookings.",
    },
    {
      key: "User Discretion:",
      summary: "While InnerPal reviews Specialist applications, you acknowledge and agree that your interactions, sessions, and disclosures with any Specialist are at your own discretion and risk.",
    },
  ]
}

export const obj4 = {
  title: "4. User Accounts & Security",
  subTitle: "To access certain features of InnerPal, you must create a Member or Specialist account.",
  list: [
    {
      key: "Credential Security:",
      summary: "You are responsible for maintaining the confidentiality of your account credentials and password.",
    },
    {
      key: "Account Activity:",
      summary: "You agree to accept full responsibility for all activities that occur under your account.",
    },
    {
      key: "Unauthorized Access:",
      summary: "You must notify InnerPal immediately at support@innerpal.com if you suspect any unauthorized access or security breach of your account.",
    },
  ]
}

export const obj5 = {
  title: "5. Acceptable Use Policy",
  subTitle: "When using InnerPal, you agree to maintain a safe, respectful, and supportive community environment.",
  list: [
    {
      key: "Prohibited Behavior:",
      summary: "You must not engage in harassment, hate speech, abusive behavior, discrimination, sexual harassment, or unlawful activities.",
    },
    {
      key: "System Integrity:",
      summary: "You agree not to attempt to breach platform security, reverse engineer platform software, or inject malicious code.",
    },
    {
      key: "Privacy of Others:",
      summary: "You must respect the privacy and confidentiality of other Members and Specialists in workshops, community forums, or sessions.",
    },
  ]
}

export const obj6 = {
  title: "6. Billing, Subscriptions & Payments",
  subTitle: "Payment terms for subscription plans and individual 1-on-1 sessions booked through InnerPal:",
  list: [
    {
      key: "Free Trials:",
      summary: "If offered a free trial, payment details are required upon activation. Charges begin automatically when the trial period ends unless cancelled beforehand.",
    },
    {
      key: "Automatic Renewal:",
      summary: "Subscriptions auto-renew at the end of each billing cycle (monthly or annually) unless you cancel your subscription in account settings prior to the renewal date.",
    },
    {
      key: "Payment Processing:",
      summary: "All transactions are processed securely via third-party payment gateways (such as Stripe).",
    },
  ]
}

export const obj7 = {
  title: "7. Cancellations & Refund Policy Overview",
  subTitle:
    <>
      All cancellations, rescheduling requests, and refunds are governed by our full <Link
        target="_blank"
        component={NavLink}
        to="/refund-policy"
      >Refund Policy
      </Link>.
    </>,
  list: [
    {
      key: "Standard Cancellations (24+ Hours Notice):",
      summary: "Cancellations made 24 hours or more before a scheduled session are eligible for a 100% full refund.",
    },
    {
      key: "Late Cancellations (<24 Hours Notice):",
      summary: "Cancellations made within 24 hours of the scheduled time are non-refundable.",
    },
    {
      key: "Subscription Charges:",
      summary: "Processed subscription fees are non-refundable for active billing periods.",
    },
  ]
}

export const obj8 = {
  title: "8. Intellectual Property Rights",
  subTitle: "All content on InnerPal, including logos, graphics, text, videos, courses, software, and design, is owned by or licensed to InnerPal.",
  list: [
    {
      key: "Limited License:",
      summary: "InnerPal grants you a limited, non-exclusive, non-transferable license to access and use platform content for personal, non-commercial use.",
    },
    {
      key: "Restrictions:",
      summary: "You may not copy, reproduce, distribute, modify, or create derivative works from InnerPal content without express written authorization.",
    },
  ]
}

export const obj9 = {
  title: "9. Limitation of Liability & Disclaimers",
  subTitle: "INNERPAL AND ITS SERVICES ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.",
  list: [
    {
      key: "No Guarantee of Results:",
      summary: "InnerPal makes no representations or warranties regarding specific emotional, personal, or life outcomes from using the platform.",
    },
    {
      key: "Liability Cap:",
      summary: "To the maximum extent permitted by law, InnerPal shall not be liable for indirect, incidental, punitive, or consequential damages resulting from your use of the platform.",
    },
  ]
}

export const obj10 = {
  title: "10. Indemnification",
  subTitle: "You agree to defend, indemnify, and hold harmless InnerPal, its officers, directors, employees, and agents from any claims, damages, liabilities, costs, or expenses arising from your violation of these Terms or your use of the Platform.",
}

export const obj11 = {
  title: "11. Termination & Suspension",
  subTitle: "InnerPal reserves the right to suspend or terminate your account and access to the Platform at our sole discretion, without prior notice, if you violate these Terms or engage in conduct detrimental to the community.",
}

export const obj12 = {
  title: "12. Governing Law & Modifications",
  subTitle: "These Terms shall be governed by and construed in accordance with applicable laws. InnerPal may revise these Terms at any time by updating this page.",
  otherTitle:
    <>
      If you have any questions regarding these Terms, please contact us at [<Link
        component={NavLink}
        to="mailto:support@innerpal.com"
      >support@innerpal.com
      </Link>].
    </>,
}